var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('trips-history-table',{attrs:{"loadBookingsCallBackFn":_vm.loadData},on:{"showDownloadModal":_vm.showDownloadModal}}),_c('dialog-wrapper',{ref:"downloadModal",attrs:{"width":600},scopedSlots:_vm._u([{key:"dialogContent",fn:function(){return [_c('trip-download-form',{on:{"closeDialog":_vm.closeDialog}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }